﻿import $ from 'jquery';

var _wa_localization_ = { currentLanguage_: $('body').data('language') }

_wa_localization_.getCurrentLanguage = function() {
    return this.currentLanguage_;
}

export default _wa_localization_;
